var GET_USER_BID_TYPES;
(function (GET_USER_BID_TYPES) {
    GET_USER_BID_TYPES[GET_USER_BID_TYPES["SENT"] = 0] = "SENT";
    GET_USER_BID_TYPES[GET_USER_BID_TYPES["RECEIVED"] = 1] = "RECEIVED";
})(GET_USER_BID_TYPES || (GET_USER_BID_TYPES = {}));

export { GET_USER_BID_TYPES };
//# sourceMappingURL=index.js.map
